import type { CertificateConfigurationResource, Repository } from "@octopusdeploy/octopus-server-client";
import { PageContent } from "~/components/PageContent/PageContent";
import Section from "~/components/Section";
import { Note } from "~/components/form";
import ServerThumbprint from "../../../../components/ServerThumbprint/ServerThumbprint";
type ThumbprintPageProps = {
    loaderData: ThumbprintPageLoaderData;
};
export type ThumbprintPageLoaderData = {
    certConfigResource: CertificateConfigurationResource;
};
export async function thumbprintPageLoader(repository: Repository): Promise<ThumbprintPageLoaderData> {
    const certificate = await repository.CertificateConfiguration.global();
    return { certConfigResource: certificate };
}
export const ThumbprintPage = ({ loaderData }: ThumbprintPageProps) => {
    const { certConfigResource } = loaderData;
    return (<PageContent header={{ title: "Thumbprint" }}>
            <Section>
                <Note>The server thumbprint below is used to identify this Octopus Server to any Tentacles when executing a deployment. You'll need the thumbprint when manually adding new Tentacle deployment targets to an environment.</Note>
                <p>
                    The server certificate uses the <strong>{certConfigResource.SignatureAlgorithm}</strong> algorithm.
                </p>
                <ServerThumbprint thumbprint={certConfigResource.Thumbprint}/>
            </Section>
        </PageContent>);
};
